import { render, staticRenderFns } from "./DocumentTypeDialog.vue?vue&type=template&id=cedbbef0&scoped=true&"
import script from "./DocumentTypeDialog.vue?vue&type=script&lang=js&"
export * from "./DocumentTypeDialog.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTypeDialog.vue?vue&type=style&index=0&id=cedbbef0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cedbbef0",
  null
  
)

export default component.exports